module.exports = __webpack_public_path__ + "media/a3.fa2f1038.mp3";